/**
 * Resolve the school id for API calls from the logged-in user.
 * Admin accounts use _id as schoolId; teachers/students use school relation.
 */
export function getSchoolIdForUser(user) {
    if (!user) return null;
    if (user.role === "Admin") {
        return user._id ?? user.id ?? null;
    }
    const fromSchool = user.school?._id ?? user.school?.id ?? null;
    const fromRecord = user.schoolId ?? null;
    return fromSchool || fromRecord || null;
}

/** Class id for a logged-in student (handles sclassName as object or string). */
export function getStudentClassId(user, userDetails = null) {
    for (const src of [userDetails, user]) {
        if (!src) continue;
        const sn = src.sclassName;
        if (typeof sn === "string" && sn.trim()) return sn.trim();
        if (sn && typeof sn === "object") {
            const id = sn._id ?? sn.id;
            if (id) return String(id);
        }
        const fromSclass = src.sclass?._id ?? src.sclass?.id;
        if (fromSclass) return String(fromSclass);
    }
    return "";
}

/** Human-readable class name for student portal headers. */
export function getStudentClassLabel(user, userDetails = null) {
    for (const src of [userDetails, user]) {
        if (!src) continue;
        const sn = src.sclassName;
        if (sn && typeof sn === "object" && sn.sclassName) {
            return String(sn.sclassName);
        }
    }
    return "";
}
